import { useBreakpoint } from '@insify/react-hooks';

import styles from './RootLayout.module.css';

import type React from 'react';

type RootLayoutProps = {
  mainElement: React.ReactNode;
  sidebarElement: React.ReactNode;
  offlineBar?: React.ReactNode;
};

if (history.scrollRestoration) {
  history.scrollRestoration = 'manual';
}

export const RootLayout: React.FC<RootLayoutProps> = ({ mainElement, sidebarElement, offlineBar }): JSX.Element => {
  const isDesktop = useBreakpoint('(min-width: 960px)');

  return (
    <>
      <main className={styles.main}>
        {offlineBar && offlineBar}
        {mainElement}
      </main>
      {isDesktop && <aside className={styles.sidebar}>{sidebarElement}</aside>}
    </>
  );
};
